import { Link, NavLink, Outlet } from 'react-router-dom';

/** Content-ops console shell, reachable at /admin (role-gated by the API). */
export function AdminLayout() {
  return (
    <div className="coach">
      <header className="coach-top">
        <Link to="/admin" className="coach-brand">
          <img src="/logo-mark.svg" width={24} height={24} alt="" />
          <span>usaCow · Content-ops</span>
        </Link>
        <nav className="coach-nav">
          <NavLink to="/admin" end>
            Inventory
          </NavLink>
          <NavLink to="/admin/qa">QA queue</NavLink>
          <Link to="/app">← Student app</Link>
        </nav>
      </header>
      <main className="coach-main">
        <Outlet />
      </main>
    </div>
  );
}
